/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minDistance: NonNullable<unknown>, maxDistance: NonNullable<unknown> }} Bald_Wise_Dragonfly_SpurInputs */

const fr_bald_wise_dragonfly_spur = /** @type {(inputs: Bald_Wise_Dragonfly_SpurInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.minDistance} à ${i?.maxDistance} mètres`)
};

/**

* @param {Bald_Wise_Dragonfly_SpurInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bald_wise_dragonfly_spur = /** @type {((inputs: Bald_Wise_Dragonfly_SpurInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bald_Wise_Dragonfly_SpurInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bald_wise_dragonfly_spur(inputs)
});